import { defineStore } from 'pinia';

interface MobileMenuState {
  isOpen: boolean;
}

const useMobileMenuStore = defineStore('mobileMenu', {
  state: (): MobileMenuState => ({
    isOpen: false,
  }),
  actions: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
});

export default useMobileMenuStore;
